<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-13 09:52:31
 * @LastEditTime: 2019-11-19 10:32:57
 * @LastEditors: Please set LastEditors
 -->
<!--  -->
<template>
  <el-dialog
    :visible.sync="ucFormSet.formVisible"
    title="信息"
    style="text-align: left"
    width="300px"
    class="dialogTheme"
    :modal-append-to-body='false'
  >

    <el-form
      label-position="left"
      label-width="70px"
    >

      <el-form-item label="选择分组">
          
          <el-select  filterable  v-model="curFolderId">
            <el-option
              v-for="tempFolder in folders.objects"
              :key="tempFolder.id"
              :value="tempFolder.id"
              :label="tempFolder.name"
            ></el-option>
          </el-select>
          
      </el-form-item>

      <el-form-item style="text-align: right">
        <el-button @click="hideForm">取消</el-button>
        <el-button @click="_save">确定</el-button>
      </el-form-item>

    </el-form>

  </el-dialog>

</template>


<script>
import { UCOperationType } from "../../UCComponentJs.js";
import { ServiceUrlConfig } from "../../../../config/ServiceUrlConfigJs.js";
import {DateUtility} from "../../../../utility/common/DateUtility.js";
import {
  UserCollectFolder,
  UserCollectFolderFilter,
  UserCollectFolders,
  UserCollectFolderFilterResult,
  UserCollectItem
} from "../../model/UserCollectJs.js";

import { UCCollectFolderEvents } from "../../collectFolder/UCCollectFolderJs.js";
import { DrawPolycurveOverlayEvents } from './DrawPolycurveOverlayJs';
import { POISurroundOverLayEvents } from './POISurroundOverLayJs';
import { TdtUser } from '../../model/TdtUserJs';

export default {
  name: "UCFormSelectCollectFolder",
  data() {
    return {

      ucFormSet:{formVisible:false},
      
      folders:new UserCollectFolders(),

      curFolderId:null,

      //传递的对象
      tagObject:null,
      
      
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    init() {
      
        this.folders = new UserCollectFolders();

        this._initDataProvider();
    },

    on_selectFolderFinished(callback)
    {
      this.$on(DrawPolycurveOverlayEvents.UCFormSelectCollectFolder_event_selectFolderFinished,callback);
    },

    off_selectFolderFinished(callback)
    { 
        this.$off(DrawPolycurveOverlayEvents.UCFormSelectCollectFolder_event_selectFolderFinished,callback);
    },

    on_surroundSelectFolderFinished(callback)
    { 
      this.$on(POISurroundOverLayEvents.UCFormSelectCollectFolder_event_selectFolderFinished,callback);
    },

    off_surroundSelectFolderFinished(callback)
    { 
      
      this.$off(POISurroundOverLayEvents.UCFormSelectCollectFolder_event_selectFolderFinished,callback);
    },



    /**
     * 显示form窗体
     */
    showForm() {
      this.ucFormSet.formVisible = true;
    },

    /**
     * 隐藏form窗体
     */
    hideForm() {
      this.ucFormSet.formVisible = false;
    },

    

    
    _initDataProvider() {
      let self = this;

      let filter = new UserCollectFolderFilter();
      if(TdtUser.currentUser)
      {
        filter.useUserId=true;
        filter.userId=TdtUser.currentUser.name;
      }

      let selectUrl = ServiceUrlConfig.platform_collectfolder_selectByFilter;

      UserCollectFolders.selectByFilter(
        filter,
        selectUrl,
        function(response) {
          if (response) {
            let filterResult = UserCollectFolderFilterResult.fromJson(response);
            if (filterResult && filterResult.filterFolders) {
              self.folders = filterResult.filterFolders;

              if(self.folders && self.folders.objects.length>0)
              { 
                self.curFolderId=self.folders.objects[0].id;
              }
            }
          }
        },
        function(erorr) {}
      );
    },


    
    

    _save() {
      let self = this;

      //校验参数输入是否有误
      let checkStatus = this._ucValidityCheck();

      if(checkStatus)
      {
        this._selectFolderFinished();
      }
      
    },

    _ucValidityCheck(checkCallback) {
      let checkStatus = false;

      if (this.curFolderId == null || this.curFolderId.trim() == "") {
        //提示
        this.$alert("未选择收藏夹", "提示", {
          confirmButtonText: "确定"
        });

        return false;
      }

      return true;
      
    },

    /**
     * 选择收藏夹完成
     */
    _selectFolderFinished() {

      let curFolder=null;

      if(this.curFolderId)
      { 
        curFolder=this.folders.findById(this.curFolderId);
      }
      

      
      this.$emit(DrawPolycurveOverlayEvents.UCFormSelectCollectFolder_event_selectFolderFinished,curFolder,this.tagObject);
      

      this.hideForm();
    },
    
  }
};
</script>


<style lang="scss" scoped>
.el-form-item {
  margin-top: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  margin-left: 5px;
}
</style>